module.exports = __webpack_public_path__ + "img/ensaladilla.0d80708b.png";